module.exports = __webpack_public_path__ + "static/media/sun-dust.16fae036.svg";